import styled from "styled-components";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import InstructorItem from "../../components/instructor/InstructorItem";
import useInstructor from "../../hooks/instructor/useInstructor";

function Instructor(){
    const {instructorList} = useInstructor();
    const renderInstructorList = () => {
        if(instructorList.length){
            return instructorList.map((item, index) => {
                return <InstructorItem key={item.id} id={item.id} profileImg={item.profile_img} name={item.name} history={item.history.replace(/\\n/g, "\n")} description={item.description}/>
            })
        }
        return null;
    }
    return(
        <Container>
            <Header />
            <div className="inner">
                <Content>
                    <Title>강사소개</Title>
                    <InstructorList>
                        {renderInstructorList()}
                    </InstructorList>
                </Content>
            </div>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 80px;
    padding-top: 160px;
    padding-bottom: 80px;
`

const Title = styled.div`
    font-size: 40px;
    font-weight: 700;
`

const InstructorList = styled.div`
    justify-content: space-between;
    display: grid;
    gap: 40px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    justify-items: center; /* Center items horizontally in the grid */

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export default Instructor;